import { httpClient } from "../utils/http.client";
import { API_ENDPOINTS } from "../config/api.config";

export const roleService = {
  getUserTypes: async () => {
    return await httpClient.get(API_ENDPOINTS.ROLE.USER_TYPES);
  },

  getRoles: async (params) => {
    return await httpClient.get(API_ENDPOINTS.ROLES.LIST, { params });
  },

  getRoleById: async (id) => {
    return await httpClient.get(`${API_ENDPOINTS.ROLES.DETAIL}/${id}`);
  },

  createRole: async (roleData) => {
    return await httpClient.post(API_ENDPOINTS.ROLES.CREATE, roleData);
  },

  updateRole: async (id, roleData) => {
    return await httpClient.put(
      `${API_ENDPOINTS.ROLES.UPDATE}/${id}`,
      roleData
    );
  },

  deleteRole: async (roleId) => {
    return await httpClient.delete(`${API_ENDPOINTS.ROLES.DELETE}/${roleId}`);
  },

  getRolePermissions: async (roleId) => {
    // Use query parameter format as per backend API
    return await httpClient.get(
      `${API_ENDPOINTS.ROLE.PERMISSIONS}?roleId=${roleId}`
    );
  },

  updateRolePermissions: async (roleId, permissions) => {
    // Use query parameter format as per backend API
    return await httpClient.put(
      `${API_ENDPOINTS.ROLE.PERMISSIONS}?roleId=${roleId}`,
      { permissions }
    );
  },
  getRoleMenus: async () => {
    return await httpClient.get(API_ENDPOINTS.ROLE.MENUS);
  },

  activateRole: async (roleId) => {
    return await httpClient.patch(API_ENDPOINTS.ROLES.ACTIVATE(roleId));
  },

  deactivateRole: async (roleId) => {
    return await httpClient.patch(API_ENDPOINTS.ROLES.DEACTIVATE(roleId));
  },
};
